import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';

const TicketsBadge = () => {
  const { t } = useTranslation();
  return <WhiteBadgeStyled dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.tickets_included') }} />;
};

export default TicketsBadge;
